import React, { Component } from "react";
import OwlCarousel from 'react-owl-carousel';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";


class Review extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {

      const reviewOptions = {
          stagePadding: 10,
          items: 3,
          loop: true,
          margin:15,
          smartSpeed: 1500,
          autoplay: false,
          dots: true,
          nav: true,
          navText : ["<i class='bx bx-chevron-left' ></i>","<i class='bx bx-chevron-right'></i>"],
          responsive:{
              0:{
                  items:1,
                  nav:false,
                  dots : false
              },
              800:{
                  items:2,
                  nav:false,
                  dots : false,
              },
              1000:{
                  items:3,
                  dots: true,
                  nav:false,
                  loop:true
              }
          }
      };

    return (
       <>
           {/* =============== Review area start =============== */}
           <div className="review-area mt-20">
               <div className="container">
                   <div className="row">
                       <div className="col-lg-12 col-md-12 col-sm-12">
                        <p>We <b>J.A.G Technical Service</b> a specialist in all kinds of Steel
Fabrication, Engineering &amp; Mechanical works.</p><br/>
<p>Our expertise mainly in Manufacturing, Assembly / Service /
Maintenance/ Erection &amp; Commissioning of Auto Shot Blasting
Equipment.</p><br/>
<p>The merit of our company is to offer a comprehensive service in
Equipment design, Fabrication, Supply, Erection &amp; Commissioning in
the field of Steel Fabrication.</p><br/>
<p>We can ensure timely project completion, end-to-end quality
management and budget control.</p><br/>
<p>Our team believes value engineering is an important part of our work,
and hence we provide solutions, not just products. Our team of qualified
engineering team can create and build equipment to client specifications.</p><br/>
<p>Our mission is to provide high quality service combined with trusted
client partnership, and to maintain high health and safety levels as a part
of solution to the client’s need.</p><br/>
<p>We offer expertise and services in the following areas of work…</p><br/>

<p>* Steel Fabrication &amp; Welding works <br/>
(Mild Steel, Stainless Steel &amp; Aluminium)
</p>
<p>* Engineering Jobs</p>
<p>* Pipeline Works</p>
<p>* Pipe Threading &amp; Coupling Works</p>
<p>* Machining Jobs</p>
<p>* Mixer Machines (Tile Glue / Paint Mixer)</p>
<p>* Storage Tank (Diesel, Water, Food Processing)</p>
<p>* Dust Collector Unit</p>
<p>* Blasting Booth &amp; Recovery Unit</p>
<br/>
<br/>
                       </div>
                   </div>

               </div>
           </div>
           {/* =============== Review area end =============== */}
       </>
    );
  }
}

export default Review;
